import React from "react";
import { Card, CardContent, CardHeader, Collapse, Divider } from "@mui/material";

import BankModule from "../BankModule";

export default function ProfileBanksCard({ open, onToggle, profileData, bankErrors, onBankChange }) {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 8px 28px rgba(0,0,0,0.06)",
        mb: 3,
      }}
    >
      <CardHeader
        title="Bankverbindungen"
        subheader="Fuer Rechnungsangaben und Zahlungen"
        action={onToggle()}
      />
      <Collapse in={open} timeout="auto">
        <Divider />
        <CardContent>
          <BankModule
            onBankChange={onBankChange}
            bankConnections={profileData.bankConnections || []}
            validationErrors={bankErrors}
          />
        </CardContent>
      </Collapse>
    </Card>
  );
}
